<template>
  <div id="testimonialsView">
    <mu-content-block v-if="isLoading" style="text-align: center">
      <mu-circular-progress :size="32"></mu-circular-progress>
      <br/>
      <span v-text="$t('message.loadingText')"></span>
    </mu-content-block>
    <mu-card id="addTestimonials" v-if="!isLoading">
      <mu-card-header titleClass="largeTitle blueTitle" :title="cardTitle" :subTitle="cardSubTitle" />
      <mu-card-text>
        <mu-row>
          <mu-col desktop="50">
            <form name="submitTestimonialForm" @submit.prevent="submitTestimonial">
              <mu-row class="progressImages">
                <mu-col tablet="50" desktop="50">
                  <div id="beforeImage" class="image" @click="openImage('beforeImage')">
                    <div class="instructions" v-show="!progressImage.before">
                      <mu-icon value="cloud_upload" :size="40" />
                      <span class="label" v-text="$t('message.labelBeforePhoto')"></span>
                      <vue-base64-file-upload
                        ref="beforeImage"
                        class="base64Upload"
                        disable-preview
                        placeholder="Before image"
                        accept="image/png,image/jpeg"
                        :max-size="maxSize"
                        @size-exceeded="onSizeExceeded"
                        @load="onLoadBefore"
                      ></vue-base64-file-upload>
                    </div>
                    <div class="imagePreview" v-show="progressImage.before" :style="'background-image: url('+ progressImage.before +')'"></div>
                  </div>
                </mu-col>
                <mu-col tablet="50" desktop="50">
                  <div id="afterImage" class="image" @click="openImage('afterImage')">
                    <div class="instructions" v-show="!progressImage.after">
                      <mu-icon value="cloud_upload" :size="40" />
                      <span class="label" v-text="$t('message.labelAfterPhoto')"></span>
                      <vue-base64-file-upload
                        ref="afterImage"
                        class="base64Upload"
                        disable-preview
                        placeholder="After image"
                        accept="image/png,image/jpeg"
                        :max-size="maxSize"
                        @size-exceeded="onSizeExceeded"
                        @load="onLoadAfter"
                      ></vue-base64-file-upload>
                    </div>
                    <div class="imagePreview" v-show="progressImage.after" :style="'background-image: url('+ progressImage.after +')'"></div>
                  </div>
                </mu-col>
              </mu-row>
              <div class="question" v-for="question, index in questions" :key="'question-' + index">
                <mu-text-field v-if="question.type == 'textarea'" :label="question.question" :rows="3" v-model="question.answer" :hintText="question.question_hint" multiLine fullWidth v-validate
                               :data-vv-rules="'required'"/>
                <mu-text-field v-if="question.type == 'tel'" type="tel" :label="question.question" v-model="question.answer" :hintText="question.question_hint" fullWidth />
              </div>
              <div class="terms">
                <mu-checkbox v-model="terms.agreed" />
                <span @click="terms.agreed =! terms.agreed">{{ $t('message.registerTestimonialConcent') }} <a :href="`${siteUrl}terms`" v-text="$t('message.registerTermsAndCondtions')"></a> {{ $t('message.registerTestimonialExplain') }}</span>
              </div>
              <button type="submit" style="display: none"></button>
              <mu-raised-button class="submitBtn" type="button" @click.native="submitTestimonial" :label="isSubmitting ? $t('message.savingText') : $t('message.submitText')" secondary :disabled="isSubmitting" />
            </form>
          </mu-col>
        </mu-row>
      </mu-card-text>
    </mu-card>
  </div>
</template>
<script>
  import TestimonialsApi from "../../api/Testimonials/index";

  import Config from '../../config';

  export default {
    data () {
      return {
        siteUrl: Config.siteUrl,
        isLoading: true,
        cardTitle: this.$t('message.labelAddTestimonial'),
        cardSubTitle: this.$t('message.labelTestimonialSubTitle'),
        questions: [],
        isSubmitting: false,
        terms: {
          agreed: false,
          label: ""
        },
        progressImage: {
            before: null,
            after: null,
        },
        maxSize: 3
      }
    },
    methods: {
        openImage (opt) {
            let element = $('#' + opt);
            element.find('input').click();
        },
        onLoadBefore (image) {
            let self = this;
            self.progressImage.before = image;
        },
        onLoadAfter (image) {
          let self = this;
          self.progressImage.after = image;
        },
        onSizeExceeded (size) {
          let self = this;
          self.$toastr.error(`File exceeds max file size of ${self.maxSize}`);
        },
        loadQuestions() {
          let self = this;
          TestimonialsApi.getQuestions().then((response) => {
              self.isLoading = false;
            let data = _.mapValues(response.data, (val) => {
              val.answer = "";
              return val;
            });
            self.questions = data;
          }).catch((error) => {
            if(error.response) {
              self.$toastr.error(self.$t('message.labelError'));
            }
          });
        },
        submitTestimonial() {
          let self = this;
          if (self.progressImage.before === null || self.progressImage.after === null) {
            self.$toastr.error('Please add progress pictures');
            return;
          }
          self.$validator.validateAll()
            .then(function (valid) {
              if (valid) {
                if (self.terms.agreed === true) {
                  self.isSubmitting = true;

                  let answers = _.mapValues(self.questions, (question) => {
                    return {
                      question_id : question.question_id,
                      answer      : question.answer
                    }
                  });
                  let testimonialData = {
                    beforeImage : self.progressImage.before,
                    afterImage : self.progressImage.after,
                    answers: answers
                  };
                  TestimonialsApi.saveTestimonial(testimonialData).then((response) => {
                    // if no error, show success
                    if(!response.data.error) {
                      self.$toastr.success('Thanks!, your testimonial has been submitted');
                      self.$router.push({
                        name: 'Dashboard'
                      });
                      self.isSubmitting = false;
                    }
                  }).catch((error) => {
                    if(error.response) {
                      self.$toastr.error(self.$t('message.labelError'));
                      self.isSubmitting = false;
                    }
                  });
                } else {
                  self.$toastr.error('Please accept the terms and conditions');
                  return;
                }
              } else {
                self.$toastr.error('Please fill in the form');
                return;
              }
            })
        },
        initMounted() {
            let self = this;
            self.loadQuestions();
        }
    },
    mounted () {
      let self = this;
      self.initMounted();
    }
  }
</script>
<style lang="less">
  @import "./Testimonials.less";
</style>



// WEBPACK FOOTER //
// Testimonials.vue?1b6bc6d4